import { useCallback } from 'react';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import type { TextualContent } from '../../../components/DocumentEditor/types/textual-content.type';

import type { SubmitHandler } from '../types/submit-handler.type';

interface Params {
  readonly handleSubmit: SubmitHandler;
}

export const useSpecialSectionSubmit = ({
  handleSubmit: pHandleSubmit,
}: Readonly<Params>) => {
  const { contentOriginsCodeMap } = useReferencesContext();

  const handleSubmit = useCallback(
    (
      values: TextualContent,
      {
        setSubmitting,
      }: Readonly<{ setSubmitting: (isSubmitting: boolean) => void }>,
    ) => {
      pHandleSubmit(values, contentOriginsCodeMap.Special._id);
      setSubmitting(false);
    },
    [pHandleSubmit, contentOriginsCodeMap.Special._id],
  );

  return { handleSubmit };
};
